import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';
import { Layout } from '@/components/Layout';
import Home from '@/pages/Home';
import Nosotros from '@/pages/Nosotros';
import ServiciosProyectos from '@/pages/ServiciosProyectos';
import CategoryPage from '@/pages/CategoryPage';
import ProjectDetail from '@/pages/ProjectDetail';
import Contacto from '@/pages/Contacto';
import AvisoPrivacidad from '@/pages/AvisoPrivacidad';
import NotFound from '@/pages/NotFound';
import AdminLogin from '@/pages/admin/AdminLogin';
import AdminDashboard from '@/pages/admin/AdminDashboard';
import AdminProtected from '@/pages/admin/AdminProtected';
import AdminClients from '@/pages/admin/AdminClients';
import AdminNosotros from '@/pages/admin/AdminNosotros';
import AdminServicios from '@/pages/admin/AdminServicios';
import AdminServicioEdit from '@/pages/admin/AdminServicioEdit';
import AdminProyectos from '@/pages/admin/AdminProyectos';
import AdminProyectoEdit from '@/pages/admin/AdminProyectoEdit';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Admin routes — NO shared Layout, standalone UI */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminProtected><AdminDashboard /></AdminProtected>} />
          <Route path="/admin/clientes" element={<AdminProtected><AdminClients /></AdminProtected>} />
          <Route path="/admin/nosotros" element={<AdminProtected><AdminNosotros /></AdminProtected>} />
          <Route path="/admin/servicios" element={<AdminProtected><AdminServicios /></AdminProtected>} />
          <Route path="/admin/servicios/:id" element={<AdminProtected><AdminServicioEdit /></AdminProtected>} />
          <Route path="/admin/proyectos" element={<AdminProtected><AdminProyectos /></AdminProtected>} />
          <Route path="/admin/proyectos/:id" element={<AdminProtected><AdminProyectoEdit /></AdminProtected>} />
          <Route path="/admin/*" element={<AdminProtected><AdminDashboard /></AdminProtected>} />

          {/* Public site */}
          <Route path="/*" element={
            <Layout>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/nosotros" element={<Nosotros />} />
                <Route path="/servicios-proyectos" element={<ServiciosProyectos />} />
                <Route path="/servicios/:serviceSlug" element={<CategoryPage />} />
                <Route path="/proyectos/:slug" element={<ProjectDetail />} />
                <Route path="/contacto" element={<Contacto />} />
                <Route path="/aviso-privacidad" element={<AvisoPrivacidad />} />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </Layout>
          } />
        </Routes>
      </BrowserRouter>
      <Toaster
        theme="dark"
        position="top-right"
        toastOptions={{
          style: {
            background: '#141414',
            color: '#fff',
            border: '1px solid rgba(255,255,255,0.1)',
          },
        }}
      />
    </div>
  );
}

export default App;
